let animeScroll = (function(){
	let jaAnimou 	= false;
	let hasAnimated = function(){
		let wh = (window.innerHeight - 100);

		$('[data-animate]').each(function(){
			let animacao = $(this).data('animate');

			if(this.getBoundingClientRect().top <= wh){
				$(this).addClass(animacao);
				$(this).removeAttr('data-animate');
			}
		})
	}


	$(window).scroll(function(){
		if(jaAnimou) return;

		setTimeout(function(){
			jaAnimou = false;
		});

		hasAnimated();
	});

	return hasAnimated();
})();